import { render, staticRenderFns } from "./OneMessage.vue?vue&type=template&id=30882a74&scoped=true"
import script from "./OneMessage.vue?vue&type=script&lang=js"
export * from "./OneMessage.vue?vue&type=script&lang=js"
import style0 from "./OneMessage.vue?vue&type=style&index=0&id=30882a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30882a74",
  null
  
)

export default component.exports